import { socialIconsArr } from '@utils/socialIcons';
import { Picture } from '@ui';
import type { FC } from 'react';
import './index.scss';

interface FooterSocialIconsProps {
  isDarkGrey?: boolean;
}

const FooterSocialIcons: FC<FooterSocialIconsProps> = ({
  isDarkGrey = false
}) => (
  <div className='FooterSocialIcons'>
    {socialIconsArr?.map(item => (
      <a
        key={item.href}
        href={item.href}
        target='_blank'
        className='FooterSocialIcons__icon'
        rel='noreferrer'
      >
        <Picture
          alt={item.alt}
          height='24'
          width='24'
          icon={isDarkGrey ? item.srcDark.x3 : item.src.x3}
          iconHover={item.srcHover.x3}
        />
      </a>
    ))}
  </div>
);

export default FooterSocialIcons;
